<template>
<div>

    <p><b>Personal Phone Numbers</b></p>

    <m-view-personal-device
        v-for="(item, index) in profile.employee_account.personal_devices"
        :key="index"
        :device="item"
        :index="index"
        :can_write="can_write"
        v-on:delete="onDeletePersonalDevice"
        v-on:edit="onEditPersonalDevice"
    />

    <m-icon-bar
        v-on:add="onAddPersonalDevice"
        style="margin-bottom: 5px;"
        v-show="can_write"
    />

    <m-edit-personal-device-dialog
        ref="edit_personal_device_dialog"
        v-on:ok="onUpsertPersonalDevice"
    />

    <p><b>Notification Email Address(es)</b></p>

    <v-card
        style="margin-bottom: 10px;"
        v-for="(device, index) in profile.employee_account.employee_notification_device_emails"
        :key="'nde_'+index"
    >
        <v-list-item>
            <v-list-item-icon>
                <v-icon>
                    mdi-phone
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="headline">{{device.label}}</v-list-item-title>
                <v-list-item-subtitle>{{device.email}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{$rc.pretty(device.mode,'enum_employee_notification_mode')}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-card-actions
            v-show="can_write"
        >
            <v-spacer/>
            <v-btn
                text
                color="primary"
                v-on:click="onEditEmail(index)"
            >
                Edit
            </v-btn>
            <v-btn
                text
                color="primary"
                v-on:click="onDeleteEmail(index)"
            >
                Delete
            </v-btn>
        </v-card-actions>

    </v-card>

    <m-icon-bar
        v-on:add="onAddNotificationEmail"
        style="margin-bottom: 5px;"
        v-show="can_write"
    />

    <m-edit-employee-notification-email-dialog
        ref="edit_notification_email_dialog"
        v-on:ok="onUpsertEmail"
    />

    <p><b>Notification via Pushover</b></p>

    <v-card
        style="margin-bottom: 10px;"
        v-for="(device, index) in profile.employee_account.employee_notification_device_pushovers"
        :key="'ndp_'+index"
    >
        <v-list-item>
            <v-list-item-icon>
                <v-icon>
                    mdi-phone
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="headline">{{device.label}}</v-list-item-title>
                <v-list-item-subtitle>{{device.user_key}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{$rc.pretty(device.mode,'enum_employee_notification_mode')}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-card-actions
            v-show="can_write"
        >
            <v-spacer/>
            <v-btn
                text
                color="primary"
                v-on:click="onEditPushover(index)"
            >
                Edit
            </v-btn>
            <v-btn
                text
                color="primary"
                v-on:click="onDeletePushover(index)"
            >
                Delete
            </v-btn>
        </v-card-actions>

    </v-card>

    <m-icon-bar
        v-on:add="onAddPushover"
        style="margin-bottom: 5px;"
        v-show="can_write"
    />

    <m-edit-employee-notification-pushover-dialog
        ref="edit_notification_pushover_dialog"
        v-on:ok="onUpsertPushover"
    />


</div>
</template>

<script>
var _ = require('lodash');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    methods: {
        onAddPersonalDevice() 
        {
            this.$refs['edit_personal_device_dialog'].showDialog();
        },

        onEditPersonalDevice(index)
        {
            this.$refs['edit_personal_device_dialog'].showDialog(index, this.profile.employee_account.personal_devices[index]);
        },

        onEditEmail(index)
        {
            let device = _.cloneDeep(this.profile.employee_account.employee_notification_device_emails[index]);
            device.index = index;

            this.$refs['edit_notification_email_dialog'].showDialog(device);
        },

        onEditPushover(index)
        {
            let device = _.cloneDeep(this.profile.employee_account.employee_notification_device_pushovers[index]);
            device.index = index;

            this.$refs['edit_notification_pushover_dialog'].showDialog(device);
        },

        onDeletePersonalDevice(index)
        {
            if ( !confirm("Delete this personal phone number?") )
                return;

            let personal_devices = _.cloneDeep(this.profile.employee_account.personal_devices);
            personal_devices.splice(index,1);

            let changes = {
                'personal_devices' : personal_devices,
            };

            this.$emit('patch-employee-account',changes);
        },

        onDeleteEmail(index)
        {
            if ( !confirm("Delete this email address?") )
                return;

            let employee_notification_device_emails = _.cloneDeep(this.profile.employee_account.employee_notification_device_emails);
            employee_notification_device_emails.splice(index,1);

            let changes = {
                'employee_notification_device_emails' : employee_notification_device_emails,
            };

            this.$emit('patch-employee-account',changes);
        },

        onDeletePushover(index)
        {
            if ( !confirm("Delete this pushover account?") )
                return;

            let employee_notification_device_pushovers = _.cloneDeep(this.profile.employee_account.employee_notification_device_pushovers);
            employee_notification_device_pushovers.splice(index,1);

            let changes = {
                'employee_notification_device_pushovers' : employee_notification_device_pushovers,
            };

            this.$emit('patch-employee-account',changes);
        },

        onUpsertPersonalDevice(device)
        {
            let personal_devices = _.cloneDeep(this.profile.employee_account.personal_devices);

            if ( device.index == -1 )
                personal_devices.push(device);
            else
                personal_devices[device.index] = device;
            
            let changes = {
                'personal_devices' : personal_devices,
            };

            this.$emit('patch-employee-account',changes);
        },

        onUpsertEmail(device)
        {
            let personal_devices = _.cloneDeep(this.profile.employee_account.employee_notification_device_emails);

            if ( device.index == -1 )
                personal_devices.push(device);
            else
                personal_devices[device.index] = device;
            
            let changes = {
                'employee_notification_device_emails' : personal_devices,
            };

            this.$emit('patch-employee-account',changes);
        },

        onUpsertPushover(device)
        {
            let personal_devices = _.cloneDeep(this.profile.employee_account.employee_notification_device_pushovers);

            if ( device.index == -1 )
                personal_devices.push(device);
            else
                personal_devices[device.index] = device;
            
            let changes = {
                'employee_notification_device_pushovers' : personal_devices,
            };

            this.$emit('patch-employee-account',changes);
        },

        onAddNotificationEmail()
        {
            this.$refs['edit_notification_email_dialog'].showDialog();
        },

        onAddPushover()
        {
            this.$refs['edit_notification_pushover_dialog'].showDialog();
        },
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        }
    },
}
</script>

<style lang="scss" scoped>

</style>